<div *ngIf="user$ | async as user; else loading">
  {{ user.givenName }} {{ user.surname }}
</div>

<ng-template #loading>
  <mat-spinner diameter="30"></mat-spinner>
</ng-template>
